import React from "react";

import styles from "./Loader.module.scss";

const Loader = () => (
  <div className={styles.loaderContainer}>
    <div className={styles.triangle}>
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default Loader;
